import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const links = ["about", "mission", "method", "services", "why", "contact"];

export const Navbar = () => {
  const { t, lang, toggle } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "border-b border-zinc-200/60 bg-white/70 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 sm:px-12">
        <button
          data-testid="brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex flex-col items-start leading-none"
        >
          <span className="font-heading text-lg font-semibold tracking-tight text-zinc-900">
            Angelo Zaia
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
            Systems · Resilience
          </span>
        </button>

        <div className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <button
              key={l}
              data-testid={`nav-${l}`}
              onClick={() => go(l)}
              className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-500 transition-colors hover:text-zinc-900"
            >
              {t.nav[l]}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <button
            data-testid="lang-toggle"
            onClick={toggle}
            className="flex items-center gap-1 font-mono text-xs font-medium tracking-widest text-zinc-900"
          >
            <span className={lang === "it" ? "text-zinc-900" : "text-zinc-400"}>IT</span>
            <span className="text-zinc-300">/</span>
            <span className={lang === "en" ? "text-zinc-900" : "text-zinc-400"}>EN</span>
          </button>
          <button
            data-testid="nav-cta"
            onClick={() => go("contact")}
            className="hidden bg-zinc-900 px-5 py-2.5 font-mono text-xs uppercase tracking-[0.15em] text-white transition-colors hover:bg-zinc-700 sm:block"
          >
            {t.nav.cta}
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="text-zinc-900 lg:hidden"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-zinc-200 bg-white px-6 py-6 lg:hidden">
          {links.map((l) => (
            <button
              key={l}
              data-testid={`mobile-nav-${l}`}
              onClick={() => go(l)}
              className="block w-full py-3 text-left font-heading text-lg text-zinc-800"
            >
              {t.nav[l]}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
